import React from 'react';
import css from './Button.css';
import Icon from 'SF/MaterialIcon';

export default class CancelButton extends React.Component {

  render() {
    return (
      <div 
        className={`${css['button']} ${css['flex']}`} 
        onClick={() => history.back()} 
        aria-label="Cancel"
        role="button" 
        tabIndex="0">
        <Icon icon='close' />
      </div>
    );
  }
}
